import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getInvoiceClaimed } from '../../../../../lib/api/dashboard';
import CenteredCircularProgress from '../../../../../lib/designSystem/CircularProgress';
import EnhancedTable from '../../../../../lib/designSystem/Table';

const InvoicesClaimed: React.FC = () => {
  const dispatch = useDispatch();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchRelations = async () => {
      setLoading(true);
      const relations = await getInvoiceClaimed(dispatch);
      setInvoices(relations || []);
      setLoading(false);
    };
    void fetchRelations();
  }, []);

  if (loading) return <CenteredCircularProgress />;

  return (
    <div>
      <Typography variant="h5">Facturas Reclamadas</Typography>
      <EnhancedTable
        dataHeaders={[
          { key: 'folio', label: 'Folio' },
          { key: 'businessName', label: 'Nombre Emisor' },
          { key: 'stakeholderName', label: 'Nombre receptor' },
          { key: 'amount', label: 'Monto', type: 'money' },
          { key: 'cancelDate', label: 'Fecha de reclamo', type: 'date' },
        ]}
        data={invoices}
        rowsPerPageDefault={5}
      />
    </div>
  );
};

export default InvoicesClaimed;
